import { AccountingReportRowReorderInput } from './../../../../types/src/mado/input-type/report-row.reorder-input';
import { AccountingReportColumnUpdateInput } from './../../../../types/src/mado/input-type/report-column.update-input';
import { AccountingReportColumnCreateInput } from './../../../../types/src/mado/input-type/report-column.create-input';
import { AccountingReportColumnGridObject, AccountingReportColumnObject } from './../../../../types/src/mado/object-type/report-column.object';
import { AccountingReportRowUpdateInput } from './../../../../types/src/mado/input-type/report-row.update-input';
import { AccountingReportRowCreateInput } from './../../../../types/src/mado/input-type/report-row.create-input';
import { AccountingReportRowGridObject, AccountingReportRowObject } from './../../../../types/src/mado/object-type/report-row.object';
import { AccountingReportRowCellGridObject, AccountingReportRowCellObject } from './../../../../types/src/mado/object-type/report-row-cell.object';
import { AccountingReportRowCellCreateInput } from './../../../../types/src/mado/input-type/report-row-cell.create-input';
import { AccountingReportRowCellUpdateInput } from './../../../../types/src/mado/input-type/report-row-cell.update-input';
import { AccountingReportUpdateInput } from './../../../../types/src/mado/input-type/report.update-input';
import { AccountingReportCreateInput } from './../../../../types/src/mado/input-type/report.create-input';
import { AccountingReportGridObject, AccountingReportObject } from './../../../../types/src/mado/object-type/report.object';
import { Injectable } from "@angular/core";
import { GqlServiceV2 } from "../modules/content/service/gql.service-v2";
import { GridInput } from "@it2go/data-grid";
import { filterFrag } from "./types/filter.types";
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';


@Injectable({ providedIn: 'root' })
export class AccountingReportGqlService extends GqlServiceV2 {

    public getAccountingReports(input: GridInput | null, frag: string) {
        return this.query<AccountingReportGridObject>(
            `
                query($input: GridInput!) {
                    accountingReport {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createAccountingReport(input: AccountingReportCreateInput, frag: string) {
        return this.mutate<AccountingReportObject>(
            `
                mutation($input: AccountingReportCreateInput!) {
                    accountingReport {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateAccountingReport(input: AccountingReportUpdateInput, frag: string) {
        return this.mutate<AccountingReportObject>(
            `
                mutation($input: AccountingReportUpdateInput!) {
                    accountingReport {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteAccountingReport(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    accountingReport {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getAccountingReportColumns(input: GridInput | null, frag: string) {
        return this.query<AccountingReportColumnGridObject>(
            `
                query($input: GridInput!) {
                    accountingReportColumn {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createAccountingReportColumn(input: AccountingReportColumnCreateInput, frag: string) {
        return this.mutate<AccountingReportColumnObject>(
            `
                mutation($input: AccountingReportColumnCreateInput!) {
                    accountingReportColumn {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateAccountingReportColumn(input: AccountingReportColumnUpdateInput, frag: string) {
        return this.mutate<AccountingReportColumnObject>(
            `
                mutation($input: AccountingReportColumnUpdateInput!) {
                    accountingReportColumn {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteAccountingReportColumn(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    accountingReportColumn {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getAccountingReportRows(input: GridInput | null, frag: string) {
        return this.query<AccountingReportRowGridObject>(
            `
                query($input: GridInput!) {
                    accountingReportRow {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createAccountingReportRow(input: AccountingReportRowCreateInput, frag: string) {
        return this.mutate<AccountingReportRowObject>(
            `
                mutation($input: AccountingReportRowCreateInput!) {
                    accountingReportRow {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateAccountingReportRow(input: AccountingReportRowUpdateInput, frag: string) {
        return this.mutate<AccountingReportRowObject>(
            `
                mutation($input: AccountingReportRowUpdateInput!) {
                    accountingReportRow {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteAccountingReportRow(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    accountingReportRow {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public reorderAccountingReportRows(input: AccountingReportRowReorderInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: AccountingReportRowReorderInput!) {
                    accountingReportRow {
                        reorder(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getAccountingReportRowCells(input: GridInput | null, frag: string) {
        return this.query<AccountingReportRowCellGridObject>(
            `
                query($input: GridInput!) {
                    accountingReportRowCell {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createAccountingReportRowCell(input: AccountingReportRowCellCreateInput, frag: string) {
        return this.mutate<AccountingReportRowCellObject>(
            `
                mutation($input: AccountingReportRowCellCreateInput!) {
                    accountingReportRowCell {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateAccountingReportRowCell(input: AccountingReportRowCellUpdateInput, frag: string) {
        return this.mutate<AccountingReportRowCellObject>(
            `
                mutation($input: AccountingReportRowCellUpdateInput!) {
                    accountingReportRowCell {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteAccountingReportRowCell(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    accountingReportRowCell {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
